import $http, { handleError } from '@/plugins/axios'

const RESOURCE_NAME = '/admin/orders'
export default {
  getAll (params) {
    return $http().get(`${RESOURCE_NAME}/paged`, {
      params: params
    })
  },
  getCustomerOrders (params) {
    return $http().get(`${RESOURCE_NAME}/by-customer-id`, {
      params: params
    })
  },
  getByOrderNumber (orderNumber) {
    return $http().get(`${RESOURCE_NAME}/by-order-number/${orderNumber}`, { handleError: false })
      .catch(e => {
        const code = parseInt(e.response && e.response.status)
        if (code === 404) { // If an order isn't found, the component will display an 'Order not found' page
          return
        }
        handleError(e)
      })
  },

  createOpenOrderIntents (selectedOrderIds, forcePrintoutGeneration, statuses, documentType) {
    return $http().post('/admin/open-order-intents', {
      applyToFilter: {
        orderIds: selectedOrderIds,
        statuses
      },
      documentType: documentType,
      forcePrintoutGeneration: forcePrintoutGeneration
    })
      .then(res => res)
  },

  getOrderPrintStatus (taskId) {
    return $http().get(`/admin/order-print-status/${taskId}`).then(res => res)
  },
  getOrderPrintStatuses () {
    return $http().get(`/admin/order-print-statuses`).then(res => {
      console.log(res)
      return res.value
    })
  },

  createFulfillOrderIntents (selectedOrderIds) {
    return $http().post('/admin/fulfill-order-intents', {
      applyToFilter: {
        orderIds: selectedOrderIds
      }
    }).then(res => res.result)
  },

  updateOrderStatus (orderId, status, emailRequired) {
    return $http().put(`${RESOURCE_NAME}/${orderId}/order-status`, {
      id: status
    },
    {
      params: emailRequired ? { emailRequired: true } : null
    })
  },

  updateBatchStatus (orderId, batchId, status, emailRequired, bypassPayment) {
    const parameters = {
      emailRequired: emailRequired,
      bypassPayment: bypassPayment
    }
    return $http().put(`${RESOURCE_NAME}/${orderId}/batches/${batchId}/order-status`,
      {
        id: status
      },
      {
        params: parameters
      })
  },

  updateBatchPickupStatus (orderId, batchId, status) {
    return $http().put(`${RESOURCE_NAME}/${orderId}/batches/${batchId}/order-status`,
      {
        id: status
      },
      {
        params: { emailRequired: true, bypassPayment: false }
      })
  },

  updateItemStatus (orderId, batchId, itemId, status, emailRequired) {
    return $http().put(`${RESOURCE_NAME}/${orderId}/batches/${batchId}/order-line-items/${itemId}/order-status`,
      {
        id: status
      },
      {
        params: emailRequired ? { emailRequired: true } : null
      })
  },

  sendOrderConfirmationEmail (orderId) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/emails/order-confirmations`, {})
  },

  sendOrderConfirmationGroupEmail (orderId, emailOptions) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/emails/order-group-confirmations`, emailOptions)
  },

  sendBatchReceiptEmail (orderId, batchId) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/batches/${batchId}/emails/batch-receipts`, {})
  },

  sendSMSText (orderId) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/sms/text-notifications`, {})
  },

  updateOrder (order) {
    return $http().put(`${RESOURCE_NAME}/${order.id}`, order)
  },

  processPayment (intent) {
    return $http().post(`admin/process-payment-intents`, intent)
      .then((res) => res.order)
  },

  getOrderPrints () {
    return $http().get(`admin/order-prints`)
  },

  getOrderPrint (orderPrintId) {
    return $http().get(`admin/order-prints/${orderPrintId}`)
  },

  createOrderReturnIntents (orderId, batchId, returnItems, commit = false, cardAmount, giftCardInfo) {
    const payload = {
      returnItems,
      commit
    }

    if (giftCardInfo) {
      payload.cardAmount = cardAmount
      payload.giftCardIntents = giftCardInfo
    }

    return $http().post(`${RESOURCE_NAME}/${orderId}/batches/${batchId}/order-return-intents`,
      payload)
  },

  createModifyOrderPaymentIntents (orderId, paymentSourceToken, paymentMethod, billingAddress) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/modify-order-payment-intents`,
      {
        paymentSourceToken,
        paymentMethod,
        billingAddress
      }, { handleError: false })
  },

  createRefreshOrderPricingIntents (orderId, commitOrder = null) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/refresh-order-prices-intents`,
      {
        commitOrder
      })
  },

  createSplitBatchIntents (orderId, batchId, splitItems) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/batches/${batchId}/split-batch-intents`,
      {
        splitItems
      })
  },

  createModifyOrderIntent (order, commit) {
    return $http().post(`${RESOURCE_NAME}/${order.id}/modify-order-intents`, {
      order,
      commit
    })
  },

  createModifyShippingIntent (order, commit) {
    return $http().post(`${RESOURCE_NAME}/${order.id}/modify-shipping-intents`, {
      order,
      commit
    })
  },

  createMarkShippedIntent (intent) {
    return $http().post('admin/mark-shipped-intents', intent)
  },

  createOrderNote (orderId, orderNumber, newNote) {
    return $http().post(`${RESOURCE_NAME}/${orderId}/order-notes`, { OrderId: orderId, OrderNumber: orderNumber, NoteText: newNote })
  },

  deleteOrderNote (noteId, orderId) {
    const route = `${RESOURCE_NAME}/orders/${orderId}/order-notes/${noteId}`
    return $http().delete(route)
  },

  removeOrderAlert (orderId, id) {
    const route = `${RESOURCE_NAME}/orders/${orderId}/remove-order-alert/${id}`
    return $http().delete(route)
  }

}
